import DatePickerV2 from './DatePickerV2';

export default DatePickerV2;
